import { NotificationService } from 'src/app/shared/services/notification.service';
import { Topic } from './../../../follow-ups/models/riskanalysis';
import { Location } from '@angular/common';
import { inject, Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { InputNumber } from 'primeng/inputnumber';
import {
  acceptBothDecimalSeparators,
  isTemperatureControlFeature
} from 'src/app/_helpers/temperature.helper';
import { ActivatedRoute } from '@angular/router';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { ConfirmationService, SelectItem } from 'primeng/api';

import { first } from 'rxjs/operators';
import { BusinessDepartmentService } from './../../../business-department.services';
import { DeviationShared, CreateDeviationRequestDto } from '../../models/';
import { DeviationServices } from '../../services/deviation.service';

import { HelperService } from './../../../../_services/helper.service';
import { UploaderConfig } from './../../../../shared/ecpl-document-explorer/uploader-config';
import { BaseServices } from './../../../kuba.services';
import { deviationCaseType } from './../../models/deviationCaseType';
import { Department } from './../../models/deviationDepartment';
import { TranslateService } from '@ngx-translate/core';
import { FeatureKey, Rights, Status } from 'src/app/_models';
import { Options } from 'src/app/_models/options';

import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { DateService } from 'src/app/_services/date.service';

@Component({
  selector: 'deviation',
  templateUrl: 'deviation-new.component.html',
  styleUrls: ['deviation-new.component.scss'],
  standalone: false
})
export class AddDeviationComponent implements OnInit {
  //#region variables
  private readonly notifications = inject(NotificationService);
  aDeviation: any = {};
  isHidden: boolean;
  value: any;
  data: any;
  caseForm: FormGroup;
  departmentForm: FormGroup;
  department = false;
  deptId: number;
  caseId: number;
  case = false;
  formDeviation: FormGroup;
  Department: SelectItem[];
  Case: SelectItem[];
  Topics: SelectItem[];
  departmentdetails: Department[];
  caseType: deviationCaseType[];
  selectedDepartment = new Department();
  selectedCaseType = new deviationCaseType();
  /**
   * A deviation is created as New, or registered as already handled. Open and Rejected are
   * reachable only from the edit screen, which is why this is a two-option subset of the
   * status group shown there.
   */
  statusOptions = [new Options(Status.New, 'NEW'), new Options(Status.Done, 'DONE')];

  parentId: number;
  parentKey: any;
  /**
   * Feature id per parent module, used when the route did not resolve
   * `additionalFeatures`. The QS, IC and OS resolvers only fetch the feature for
   * editors, so non-editor roles would otherwise POST a deviation without a
   * FeatureId and be rejected by the authorization policy with a 403.
   */
  private static readonly parentKeyFeatureIds: { [key: string]: number } = {
    QS: FeatureKey.QUALITY_SYSTEMS,
    IC: FeatureKey.INTERNAL_CONTROL,
    OS: FeatureKey.OTHER_SYSTEMS
  };
  upConfig: UploaderConfig;
  uploadedFiles: any[] = [];
  additionalData: any;
  newDocumentAdded: any = [];
  isCaseErrorDisabled: boolean;
  hidingElement = false;
  hidesElement = false;
  isDepartmentErrorDisabled: boolean;
  isCaseAllocated = false;
  isDepartmentAllocated = false;
  topicForm: FormGroup;
  topicId: number;
  editTopics: any = [];
  isTopicAllocated = false;
  isTopicErrorDisabled = false;
  addTopic: boolean;
  viewTopic: boolean;
  loading = false;
  additionalFeature: any;
  featureId: any;
  isHideGuest = true;
  isHideUser = true;
  isShowSaveButton: boolean;
  IsClear = false;
  // Food safety and Kuba Control deviations have an optional temperature and measured object
  hasTemperature = false;
  temperatureControlObjects: SelectItem[] = [];
  showMore = false;
  isShowDepartmentCheckbox: boolean;
  private subscriptions: Subscription[] = [];
  isShowEditorCheckbox: boolean;
  importances: SelectItem[];
  currentDeadLine: Date;
  currentDate: Date;
  executions: SelectItem[];
  followUps: SelectItem[];
  followUpNotify: any;
  followLabel: any;
  execLabel: any;
  selectedFollowup: string;
  minDate!: Date;
  //#endregion
  /**
   * constructor
   * @param router {{Router}}
   * @param route {{ActivatedRoute}}
   * @param formBuilder {{FormBuilder}}
   * @param deviationservice {{DeviationServices}}
   * @param location {{Location}}
   * @param confirmationService {{ConfirmationService}}
   */
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private deviationservice: DeviationServices,
    private location: Location,
    private confirmationService: ConfirmationService,
    private businessDepartmentService: BusinessDepartmentService,
    private translate: TranslateService,
    private datePipe: DatePipe,
    private dateService: DateService
  ) {
    this.parentId = this.route.snapshot.parent.parent.params['id'];
    this.parentKey = this.route.snapshot.parent.parent.data['parent'];
    this.additionalFeature =
      this.route.snapshot.parent.parent.data['additionalFeatures'];
    this.featureId =
      this.additionalFeature != null
        ? this.additionalFeature['id']
        : AddDeviationComponent.parentKeyFeatureIds[this.parentKey];
    // Topic, case and department are required by the API for every module, food safety included
    this.formDeviation = this.formBuilder.group({
      Title: ['', Validators.required],
      Description: [''],
      Status: [Status.New],
      Case: ['', Validators.required],
      Department: [[], Validators.required],
      Topics: ['', Validators.required],
      user: [''],
      deparmentOnly: [0],
      ProjectId: ['1'],
      ImmediateAction: [''],
      EventLocation: [''],
      EventDate: [''],
      EventTime: [''],
      SendonlytoEditors: [0],
      Importance: [''],
      Cost: [],
      Deadline: [],
      Execution: [],
      Followup: [],
      CauseAnalysis: [''],
      CorrectiveAction: [''],
      EffectOfAction: [''],
      Comment: [''],
      Notification: [null, [], this.notificationdays.bind(this)],
      FollowupNotification: []
    });
    // Uses the same feature id as the request, so the field matches what the backend stores
    this.hasTemperature = isTemperatureControlFeature(this.featureId);
    if (this.hasTemperature) {
      this.formDeviation.addControl(
        'Temperature',
        new FormControl<number | null>(null)
      );
      this.formDeviation.addControl(
        'ObjectName',
        new FormControl<string | null>(null)
      );
      this.loadTemperatureControlObjects();
    }
    this.caseForm = this.formBuilder.group({
      Name: ['', [Validators.required, ValidationService.noWhitespaceValidator]]
    });
    this.departmentForm = this.formBuilder.group({
      Name: ['', [Validators.required, ValidationService.noWhitespaceValidator]]
    });
    this.topicForm = this.formBuilder.group({
      Name: ['', [Validators.required, ValidationService.noWhitespaceValidator]]
    });
    switch (this.parentKey) {
      case 'FDV':
        this.isHidden = false;
        break;
      case 'PROJECT':
        this.isHidden = true;
        break;
    }
    if (+BaseServices.roleId === 4) {
      this.isHideGuest = false;
    }
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.ADMINISTRATE_DEVIATION;
    if (+BaseServices.roleId === 5) {
      this.isHideGuest = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
    }

    if (this.featureId == 20) {
      this.isShowDepartmentCheckbox = false;
      this.isShowEditorCheckbox = false;
    } else {
      this.isShowDepartmentCheckbox = true;
      this.isShowEditorCheckbox = true;
    }
  }

  /**
   * page init dropdown bind
   */
  ngOnInit(): void {
    document.querySelector('body').classList.remove('opened');
    this.minDate = new Date();
    this.minDate.setHours(0, 0, 0, 0);
    this.revalidateNotificationOnDeadlineChange();
    this.additionalData = {
      ApplicationId: BaseServices.ApplicationId,
      BusinessId: BaseServices.BusinessId,
      ParentId: this.parentId,
      ChildId: 0,
      Status: '1',
      CreatedOn: new Date(),
      ModifiedBy: BaseServices.UserId,
      ModifiedOn: new Date(),
      ModuleName: 'Deviation'
    };
    this.upConfig = {
      title: 'UPLOAD',
      titleAsLabel: true,
      editMode: true,
      windowedHeight: false,
      viewSwitch: false,
      showUserMeta: false,
      showSearchFilter: false,
      showUploadButton: true,
      showDeleteButton: true,
      uploaderUri: `${environment.BASE_URL}/${BaseServices.apiRoute(
        this.parentKey
      )}/file-upload`,
      addtionalData: this.additionalData
    };
    let topic = this.route.snapshot.data['topic'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Topics = [];
        this.Topics.push({ label: val.SELECT, value: '' });
        if (topic) {
          topic.forEach((element: any) => {
            this.Topics.push({ label: element.Name, value: element.Id });
          });
        }
      })
    );

    this.bindCaseDropdown();
    this.bindDeptDropdown();
    this.bindTopicDropDown();
    this.bindImportanceDropdown();
    this.bindFormDropdown();
  }

  /**
   * save uploaded file
   */
  saveUploaded(event: any) {
    if (event) {
      let eventType = event.eventName;
      let keyBindings = {
        Originalname: 'OriginalFileName',
        FileTypeId: 'FileType'
      };
      let deviationDoc = Object.assign({}, event, this.additionalData);
      switch (eventType) {
        case 'DeleteDefaultFile':
          this.uploadedFiles = this.uploadedFiles.filter(
            (x: any) => x.path !== event.item.data.path
          );
          if (event.item.data.id === 0) {
            this.newDocumentAdded = this.newDocumentAdded.filter(
              (x: any) => x.Path !== event.item.data.path
            );
          } else {
            deviationDoc.id = event.item.data.id;
            deviationDoc.createdBy = BaseServices.UserId;
            deviationDoc.status = 2;
            this.newDocumentAdded.push(
              HelperService.switchKeysCase(deviationDoc, keyBindings)
            );
          }
          break;
        default:
          deviationDoc.id = 0;
          deviationDoc.createdBy = BaseServices.UserId;
          deviationDoc.status = 1;
          this.newDocumentAdded.push(
            HelperService.switchKeysCase(deviationDoc, keyBindings)
          );
          break;
      }
    }
  }
  /**
   * bind case dropdown
   */
  bindCaseDropdown() {
    this.data = this.route.snapshot.data['caseType'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Case = [];
        this.Case.push({ label: val.SELECT, value: null });
        if (this.data) {
          this.data.forEach((element: any) => {
            this.Case.push({ label: element.Name, value: element.Id });
          });
        }
      })
    );
  }

  /**
   * bind department dropdown
   */
  bindDeptDropdown() {
    this.Department = [];
    let departments = this.route.snapshot.data['department'];
    let department = _.filter(departments, { ParentId: null });
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Department = [];
        if (department) {
          department.forEach((departmentList: any) => {
            if (departmentList.Id) {
              let subDepartment = _.filter(departments, {
                ParentId: departmentList.Id
              });
              if (subDepartment.length > 0) {
                subDepartment.forEach((subDepartmentList: Department) => {
                  departmentList.Name += ' (' + subDepartmentList.Name + ')';
                });
              }
            }
            this.Department.push({
              label: departmentList.Name,
              value: departmentList.Id
            });
          });
        }
      })
    );
  }
  /**
   * bind topic dropdown
   */
  bindTopicDropDown() {
    this.subscriptions.push(
      this.deviationservice
        .getAllTopics(BaseServices.BusinessId)
        .subscribe((topic: any) => {
          if (topic) {
            this.subscriptions.push(
              this.translate.stream('SELECT_DROPDOWN').subscribe((val: any) => {
                this.Topics = [];
                this.Topics.push({ label: val.SELECT, value: '' });
                topic.forEach((element: any) => {
                  this.Topics.push({ label: element.Name, value: element.Id });
                });
                this.editTopics = topic;
              })
            );
          }
        })
    );
  }
  /**
   * bind case dropdown
   */
  refreshCaseType() {
    this.isCaseErrorDisabled = false;
    this.subscriptions.push(
      this.deviationservice.getAllCaseType().subscribe((cases: any) => {
        this.subscriptions.push(
          this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
            this.Case = [];
            this.Case.push({ label: val.SELECT, value: null });
            if (cases) {
              cases.forEach((caseValue: any) => {
                this.Case.push({
                  label: caseValue.Name,
                  value: caseValue.Id
                });
              });
            }
          })
        );
        this.caseType = cases;
      })
    );
  }

  /**
   * get dropdown values for editing
   * @param casetype
   */
  editCase(casetype: any) {
    this.selectedCaseType = casetype;
    this.caseId = this.selectedCaseType.Id;
  }

  /**
   * display case dropdown
   */
  showCase() {
    this.case = true;
  }

  /**
   * // save case dropdown
   */
  saveCase() {
    let casetype = new deviationCaseType();
    casetype.Id = this.caseId ? this.caseId : 0;
    casetype.Name = this.selectedCaseType.Name;
    casetype.Status = '1';
    casetype.BusinessId = BaseServices.BusinessId;
    casetype.ApplicationId = BaseServices.ApplicationId;
    if (casetype.Id > 0) {
      this.subscriptions.push(
        this.deviationservice
          .updateCaseType(casetype)
          .subscribe((caseType: any) => {
            if (caseType) {
              this.case = false;
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.refreshCaseType();
              this.formDeviation.get('Case').patchValue(caseType.Id);
              this.caseId = 0;
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.deviationservice
          .checkTypecaseExist(casetype.Name)
          .subscribe((result: any) => {
            if (result.Isavailable === true) {
              this.isCaseErrorDisabled = true;
            } else {
              this.subscriptions.push(
                this.deviationservice
                  .createCaseType(casetype)
                  .subscribe((caseType: any) => {
                    if (caseType) {
                      this.case = false;
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                      this.refreshCaseType();
                      this.formDeviation.get('Case').patchValue(caseType.Id);
                    }
                  })
              );
            }
          })
      );
    }
    this.clearCase();
  }
  clearCase() {
    this.selectedCaseType.Id = 0;
    this.caseForm = this.formBuilder.group({
      Name: ['']
    });
  }
  /**
   * delete case dropdown
   * @param selectedCaseType
   */
  deleteCase(selectedCaseType: any) {
    this.subscriptions.push(
      this.deviationservice
        .checkDepartmentExist(selectedCaseType)
        .subscribe((result: any) => {
          if (result) {
            this.isCaseAllocated = true;
            setTimeout(
              function () {
                this.isCaseAllocated = false;
              }.bind(this),
              3000
            );
          } else {
            this.confirmationService.confirm({
              message: this.translate.instant('DELETE_THIS_RECORD'),
              accept: () => {
                this.subscriptions.push(
                  this.deviationservice
                    .deleteType(selectedCaseType)
                    .subscribe(result => {
                      if (result) {
                        this.refreshCaseType();
                        this.notifications.success('UI_NOTIFICATIONS.DELETED');
                      }
                    })
                );
              }
            });
          }
        })
    );
  }
  /**
   * edit topic
   * @param Topic {{any}}
   */
  editTopic(topic: any) {
    this.topicId = topic.Id;
    let topicControl = {
      Name: topic.Name
    };
    (<FormGroup>this.topicForm).setValue(topicControl, { onlySelf: true });
  }

  /**
   * delete type of topic
   * @param deleteTopic {{any}}
   */
  deleteTopic(deleteTopic: any) {
    this.subscriptions.push(
      this.deviationservice
        .checkTopicForDeviation(deleteTopic)
        .subscribe((result: any) => {
          if (result) {
            this.isTopicAllocated = true;
            setTimeout(
              function () {
                this.isTopicAllocated = false;
              }.bind(this),
              3000
            );
          } else {
            this.confirmationService.confirm({
              message: this.translate.instant('DELETE_THIS_RECORD'),
              accept: () => {
                this.subscriptions.push(
                  this.deviationservice
                    .deleteTopics(deleteTopic)
                    .subscribe(isTopicDeleted => {
                      if (isTopicDeleted) {
                        this.fetchTopic();
                        this.notifications.success('UI_NOTIFICATIONS.DELETED');
                      }
                    })
                );
              }
            });
          }
        })
    );
  }
  /**
   * Fetch the topics
   */
  fetchTopic() {
    this.isTopicErrorDisabled = false;
    this.subscriptions.push(
      this.deviationservice
        .getAllTopics(BaseServices.BusinessId)
        .subscribe((topic: any) => {
          this.subscriptions.push(
            this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
              this.Topics = [];
              this.Topics.push({ label: val.SELECT, value: null });
              if (topic) {
                topic.forEach((topicValue: any) => {
                  this.Topics.push({
                    label: topicValue.Name,
                    value: topicValue.Id
                  });
                });
              }
            })
          );
          this.editTopics = topic;
        })
    );
  }
  /**
   * save topic
   */
  saveTopic() {
    let topic = new Topic();
    topic.Id = this.topicId ? this.topicId : 0;
    topic.Name = this.topicForm.value.Name;
    topic.Status = '1';
    topic.BusinessId = BaseServices.BusinessId;
    if (topic.Id > 0) {
      this.subscriptions.push(
        this.deviationservice
          .updateTopics(topic)
          .subscribe((topicEdited: any) => {
            if (topicEdited) {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.addTopic = false;
              this.fetchTopic();
              this.formDeviation.get('Topics').patchValue(topicEdited.Id);
              this.topicId = 0;
            } else {
              this.isTopicErrorDisabled = true;
              setTimeout(
                function () {
                  this.isTopicErrorDisabled = false;
                }.bind(this),
                3000
              );
            }
          })
      );
    } else {
      this.isTopicErrorDisabled = false;
      this.subscriptions.push(
        this.deviationservice.addTopics(topic).subscribe((caseType: any) => {
          if (caseType) {
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.addTopic = false;
            this.fetchTopic();
            this.formDeviation.get('Topics').patchValue(caseType.Id);
          } else {
            this.isTopicErrorDisabled = true;
            setTimeout(
              function () {
                this.isTopicErrorDisabled = false;
              }.bind(this),
              3000
            );
          }
        })
      );
      this.topicForm.reset();
    }
  }
  /**
   * get all department dropdown list
   */

  viewDepartment() {
    this.isDepartmentErrorDisabled = false;
    this.departmentdetails = []; // Clear the array before loading new data
    this.subscriptions.push(
      this.businessDepartmentService
        .getCachedBusinessDepartment()
        .subscribe(department => {
          if (department) {
            // Use first() to prevent multiple subscriptions when language changes
            this.translate.stream('SELECT_DROPDOWN').pipe(
              first()
            ).subscribe(val => {
              this.Department = [];
              this.Department.push({ label: val.SELECT, value: null });
              if (department) {
                department.forEach((caseValue: any) => {
                  this.Department.push({
                    label: caseValue.Name,
                    value: caseValue.Id
                  });
                });
              }
            });
            this.departmentdetails = department;
          }
        })
    );
  }

  /**
   * get department values for edit
   * @param deptdetails
   */
  editDepartment(deptdetails: any) {
    this.deptId = this.selectedDepartment.Id;
    this.selectedDepartment = deptdetails;
  }

  /**
   * display department dropdown
   */
  showDepartment() {
    this.department = true;
  }

  /**
   * save department dropdown
   */
  saveDepartment() {
    let deptdetails = new Department();
    deptdetails.BusinessId = BaseServices.BusinessId;
    deptdetails.ApplicationId = BaseServices.ApplicationId;
    deptdetails.Id = this.deptId ? this.deptId : 0;
    deptdetails.Name = this.selectedDepartment.Name;
    deptdetails.Status = '1';
    if (deptdetails.Id > 0) {
      deptdetails.ModifiedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.deviationservice
          .updateDepartment(deptdetails)
          .subscribe((department: any) => {
            if (department) {
              this.clearCachedDepartment();
              this.department = false;
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.viewDepartment();
              this.bindDeptDropdown();
              this.selectDepartment(department.Id);
              this.deptId = 0;
            }
          })
      );
    } else {
      this.clearCachedDepartment();
      deptdetails.Id = 0;
      deptdetails.CreatedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.deviationservice
          .checkDepartmentExist(deptdetails.Name)
          .subscribe((result: any) => {
            if (result.Isavailable === true) {
              this.isDepartmentErrorDisabled = true;
            } else {
              this.subscriptions.push(
                this.deviationservice
                  .addDepartment(deptdetails)
                  .subscribe((department: any) => {
                    if (department) {
                      this.department = false;
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                      this.viewDepartment();
                      this.bindDeptDropdown();
                      this.selectDepartment(department.Id);
                    }
                  })
              );
            }
          })
      );
    }
    this.clearDepartment();
  }

  private selectDepartment(departmentId: number): void {
    const control = this.formDeviation.controls['Department'];
    const selectedIds: number[] = Array.isArray(control.value) ? control.value : [];
    control.setValue([...new Set([...selectedIds, departmentId])]);
  }

  /**
   * clear popup value
   */
  clearDepartment() {
    this.selectedDepartment.Id = 0;
    this.departmentForm = this.formBuilder.group({
      Name: ['']
    });
  }
  /**
   * cache clear of department
   */
  clearCachedDepartment() {
    this.businessDepartmentService.clearCachedAllDepartment();
  }
  /**
   * Check if user can delete department based on role and BusinessId
   * @param department Department to check
   * @returns boolean indicating if deletion is allowed
   */
  canDeleteDepartment(department: Department): boolean {
    const roleId = +BaseServices.roleId;
    const restrictedRoles = [3, 4, 5]; // Editor, Guest, User

    // If BusinessId is 0 and user has restricted role, cannot delete
    if (department.BusinessId === 0 && restrictedRoles.includes(roleId)) {
      return false;
    }
    return true;
  }

  /**
   * department dropdown delete
   * @param selectedDepartment
   */
  deleteDepartment(selectedDepartment: Department) {
    // Check if user has permission to delete this department
    if (!this.canDeleteDepartment(selectedDepartment)) {
      this.notifications.add({ severity: 'error', summary: this.translate.instant('NO_PERMISSION'), detail: this.translate.instant('NO_PERMISSION_TO_DELETE_THIS_DEPARTMENT') });
      return;
    }

    if (selectedDepartment.BusinessId > 0) {
      this.subscriptions.push(
        this.deviationservice
          .checkDepartmentExist(selectedDepartment.Name)
          .subscribe((result: any) => {
            this.confirmationService.confirm({
              message: this.translate.instant('DELETE_THIS_RECORD'),
              accept: () => {
                this.subscriptions.push(
                  this.deviationservice
                    .deleteDepartment(selectedDepartment.Id)
                    .subscribe(result => {
                      if (result) {
                        this.viewDepartment();
                        this.bindDeptDropdown();
                        this.notifications.success('UI_NOTIFICATIONS.DELETED');
                      }
                    })
                );
              }
            });
          })
      );
    }
  }

  /**
   * close popup
   */
  onBeforeCaseDialogHide() {
    this.isCaseErrorDisabled = false;
    this.caseForm.reset();
    this.hidingElement = false;
    this.hidesElement = false;
    this.isDepartmentErrorDisabled = false;
  }

  /**
   * go back to list
   */
  gotoList() {
    this.location.back();
  }

  /**
   * Lets the temperature field accept both "," and "." as the decimal separator
   */
  onTemperatureKeyDown(event: KeyboardEvent, input: InputNumber): void {
    acceptBothDecimalSeparators(event, input);
  }

  /**
   * Loads the food safety / Kuba Control objects for the object dropdown. The object is stored
   * by name, the same way the automatic temperature control deviations store it.
   */
  private loadTemperatureControlObjects(): void {
    this.subscriptions.push(
      this.deviationservice
        .getTemperatureControlObjects(this.featureId, Number(this.parentId))
        .subscribe(objects => {
          this.temperatureControlObjects = (objects ?? [])
            .filter(o => !!o.ObjectName)
            .map(o => ({ label: o.ObjectName, value: o.ObjectName }));
        })
    );
  }

  /**
   * saving deviation list
   */
  saveDeviation() {
    let appSettings = JSON.parse(sessionStorage.getItem('appSettings'));
    this.loading = true;
    let formData = this.formDeviation.value;

    const request: CreateDeviationRequestDto = {
      Title: formData.Title,
      BusinessDepartmentIds: formData.Department,
      TopicId: formData.Topics,
      CaseId: formData.Case,
      FeatureId: this.featureId,
      FeatureKey: Number(this.parentId),
      BusinessId: BaseServices.BusinessId,
      Status: formData.Status,
      Description: formData.Description,
      EventDate: formData.EventDate
        ? this.dateService.formatDateToString(formData.EventDate)
        : null,
      EventTime: formData.EventTime
        ? HelperService.formatTime(formData.EventTime)
        : null,
      EventLocation: formData.EventLocation,
      ImmediateAction: formData.ImmediateAction,
      DeviationAttachments: this.newDocumentAdded,
      Deadline: formData.Deadline
        ? this.dateService.formatDateToString(formData.Deadline)
        : null,
      Importance: formData.Importance,
      Cost: formData.Cost,
      CauseAnalysis: formData.CauseAnalysis,
      CorrectiveAction: formData.CorrectiveAction,
      EffectOfAction: formData.EffectOfAction,
      Comment: formData.Comment,
      ExecutionUserId: formData.Execution,
      NotifyBeforeDeadLine: formData.Notification,
      FollowupUserId: formData.Followup,
      NotificationBeforeFollowup: formData.FollowupNotification,
      Temperature: this.hasTemperature
        ? (formData.Temperature ?? null)
        : undefined,
      ObjectName: this.hasTemperature
        ? (formData.ObjectName ?? null)
        : undefined
    };

    this.subscriptions.push(
      this.deviationservice
        .createDeviation(request)
        .subscribe(() => {
          this.loading = false;
          this.notifications.success('UI_NOTIFICATIONS.SAVED');
          this.gotoList();
        })
    );
  }

  /**
   * get current date
   */
  getCurrentDate() {
    let dateFormat = new Date();
    return {
      year: dateFormat.getFullYear(),
      month: dateFormat.getMonth() + 1,
      day: dateFormat.getDate() + 1
    };
  }

  /**
   * bind evnet date and time
   */
  bindEventDate() {
    let dateFormat = new Date();
    this.formDeviation.get('EventDate')?.setValue(new Date());
    this.formDeviation
      .get('EventTime')
      ?.setValue(this.datePipe.transform(dateFormat, 'HH:mm'));
    this.IsClear = true;
  }

  /**
   * clear evnet date and time
   */
  clearEventDate() {
    this.formDeviation.controls['EventDate'].setValue(null);
    this.formDeviation.controls['EventTime'].setValue(null);
    this.IsClear = false;
  }

  /**
   * enable clear button
   */
  enableClear() {
    this.IsClear = true;
  }

  bindImportanceDropdown() {
    this.subscriptions.push(
      this.translate.stream('RISKFIGURE_DROPDOWN').subscribe(val => {
        this.importances = [];
        this.importances.push(
          { label: val.SELECT, value: null },
          { label: val.LOW, value: 1 },
          { label: val.MEDIUM, value: 2 },
          { label: val.HIGH, value: 3 }
        );
      })
    );
  }

  /**
   * cost key press event
   * @param e {e}
   * @param limitNumber {limitNumber}
   */
  onNumber(e: any, limitNumber: any) {
    const limit = limitNumber;
    const dots = e.target.value.indexOf('.');
    let charCode = e.which ? e.which : e.keyCode;
    if (
      e.target.value.length === limit ||
      dots > 1 ||
      (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46)
    ) {
      e.preventDefault();
    }
  }

  bindFormDropdown() {
    let responsiblePerson = this.route.snapshot.data['user'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.executions = [];
        this.executions.push({ label: val.SELECT, value: null });
        if (responsiblePerson) {
          responsiblePerson.forEach((followupExecution: any) => {
            this.executions.push({
              label: followupExecution.Name,
              value: followupExecution.Id
            });
          });
        }
      })
    );
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.followUps = [];
        this.followUps.push({ label: val.SELECT, value: null });
        if (responsiblePerson) {
          responsiblePerson.forEach((followupExecution: any) => {
            this.followUps.push({
              label: followupExecution.Name,
              value: followupExecution.Id
            });
          });
        }
      })
    );

    this.followUpNotify = [];
    for (let n = 0; n <= 14; n++) {
      if (n === 0) {
        this.followUpNotify.push({
          label: this.translate.instant('ON_DEADLINE_DATE'),
          value: n
        });
      } else {
        this.followUpNotify.push({ label: n.toString(), value: n });
      }
    }
    this.followUpNotify.push(
      { label: this.translate.instant('TREE_WEEKS'), value: 21 },
      { label: this.translate.instant('ONE_MONTH'), value: 30 }
    );
  }

  /**
   * followup dropdown change event
   * @param e
   * @param followupDropdown
   */

  onFollowChanged(e: any, follow: any) {
    if (e.value) {
      this.followLabel = follow.selectedOption.label;
    }
  }

  /**
   * execution dropdown change eventF
   * @param e
   * @param executionDropdown
   */

  onExecChanged(e: any, exec: any) {
    if (e.value) {
      this.execLabel = exec.selectedOption.label;
    }
  }

  /**
   * The reminder is sent `Notification` days before the deadline. A value reaching further back
   * than today can never be delivered, so it is rejected here as well as by the backend.
   *
   * The span is signed on purpose: a deadline already in the past leaves no valid value at all,
   * and an absolute difference would quietly accept one.
   */
  notificationdays(control: FormControl) {
    return new Promise(resolve => {
      const deadline = this.formDeviation?.get('Deadline')?.value;
      if (control.value === null || control.value === undefined || !deadline) {
        resolve(null);
        return;
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const deadlineDate = new Date(deadline);
      deadlineDate.setHours(0, 0, 0, 0);

      const ONE_DAY = 1000 * 60 * 60 * 24;
      const daysUntilDeadline = Math.round(
        (deadlineDate.getTime() - today.getTime()) / ONE_DAY
      );

      resolve(control.value > daysUntilDeadline ? { notificationdays: true } : null);
    });
  }

  /**
   * An async validator only re-runs when its own control changes, so moving the deadline has to
   * re-check the notification day count explicitly.
   */
  private revalidateNotificationOnDeadlineChange() {
    const deadline = this.formDeviation.get('Deadline');
    if (!deadline) {
      return;
    }
    this.subscriptions.push(
      deadline.valueChanges.subscribe(() =>
        this.formDeviation.get('Notification')?.updateValueAndValidity()
      )
    );
  }

  /**
   * A completed deviation has nothing left to remind anyone about, so both notification fields
   * are disabled. A disabled control drops out of `form.value`, which is what clears the stored
   * days - leaving them would keep a reminder that can never be sent.
   */
  private syncNotificationFields(status: number) {
    const notification = this.formDeviation.get('Notification');
    const followupNotification = this.formDeviation.get('FollowupNotification');

    if (status === Status.Done) {
      notification?.reset();
      notification?.disable();
      followupNotification?.reset();
      followupNotification?.disable();
    } else {
      notification?.enable();
      followupNotification?.enable();
    }
  }

  /**
   * Registering a deviation as already handled puts it under the same rules as pressing
   * "Manage deviation now": the four fields below become required, so the section is opened.
   * Going back to New closes it again - but only when nothing has been entered there, since
   * closing hides the block and the user would not see what they are leaving behind.
   */
  onStatusChange(option: Options) {
    this.syncNotificationFields(option.id);

    if (option.id === Status.Done) {
      // Open the block so the handling can still be recorded, but leave the four optional
      this.ShowMore(true);
      this.setManageFieldsRequired(false);
    } else if (this.hasManageData()) {
      this.setManageFieldsRequired(true);
    } else {
      this.ShowMore(false);
    }
  }

  /**
   * True when any field in the manage block holds a value. The controls stay in the form group
   * while the section is hidden, so their values survive a close and can be read here.
   */
  private hasManageData(): boolean {
    const form = this.formDeviation.value;
    return [
      form.Deadline,
      form.Importance,
      form.Execution,
      form.Followup,
      form.Cost,
      form.CauseAnalysis,
      form.CorrectiveAction,
      form.EffectOfAction,
      form.Comment,
      form.Notification,
      form.FollowupNotification
    ].some(value => value !== null && value !== undefined && value !== '');
  }

  /**
   * The four manage fields are required together, or not at all. A completed deviation is the
   * exception: it records how the deviation was handled rather than who is going to handle it,
   * and it has no reminder that a missing responsible user could break - so there the same four
   * fields are optional. The backend applies the same exception.
   */
  private setManageFieldsRequired(required: boolean) {
    for (const name of ['Importance', 'Deadline', 'Execution', 'Followup']) {
      const control = this.formDeviation.controls[name];
      if (!control) {
        continue;
      }
      if (required) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    }
  }

  ShowMore(data: boolean) {
    if (data === true) {
      this.showMore = true;
      this.setManageFieldsRequired(true);
    } else {
      this.showMore = false;
      // Done is only reachable while the manage block is in use - closing it reverts the status
      this.formDeviation.controls['Status'].patchValue(Status.New);
      if (this.formDeviation.controls['Department']) {
        this.formDeviation.controls['Department'].setValidators(
          Validators.required
        );
        this.formDeviation.controls['Department'].updateValueAndValidity();
      }
      if (this.formDeviation.controls['Topic']) {
        this.formDeviation.controls['Topic'].setValidators(Validators.required);
        this.formDeviation.controls['Topic'].updateValueAndValidity();
      }
      if (this.formDeviation.controls['TypeCase']) {
        this.formDeviation.controls['TypeCase'].setValidators(
          Validators.required
        );
        this.formDeviation.controls['TypeCase'].updateValueAndValidity();
      }
      if (this.formDeviation.controls['Title']) {
        this.formDeviation.controls['Title'].setValidators(Validators.required);
        this.formDeviation.controls['Title'].updateValueAndValidity();
      }
      this.setManageFieldsRequired(false);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
